<div class="form-group">
    <label class="input-label">Max value:</label>
    <select class="form-control"
            name="fieldOptions.maxValue"
            [(ngModel)]="fieldOptions.maxValue"
            (ngModelChange)="dataChangedEvent($event)"
            class="form-control">
    <option value=""></option>
    <option *ngFor="let field of visibleFields" value="{{field.schema.components[0].key}}">
      {{field.schema.components[0].label}}
    </option>
    <option *ngFor="let guide of visibleGuides" value="{{guide.formIoId}}">{{guide.title}}</option>
    <!--option *ngFor="let msg of visibleNotifications" value="value=data['{{msg.key}}'];">{{msg.content}}</option>
    <option *ngFor="let tag of visibleTags" value="{{tag.name}}">{{tag.name}}</option-->
  </select>

</div>